import React from 'react';
import {Col, Container, Row
} from 'reactstrap';
import moment from 'moment';
 import TimeAgo from 'react-time-ago'
import CompletedIcon from 'react-icons/lib/md/check-circle';
import FailedIcon from 'react-icons/lib/md/cancel';
import ToolTipItem from "../utils/tooltip";
import InterpretStatus from "../utils/interpretor";
// import {appConstants} from "../../_constants";
// import {commonService} from "../../_services";

import IconMdDate from 'react-icons/lib/md/date-range';
import IconMdAirplanemodeActive from 'react-icons/lib/md/airplanemode-active';
import IconSummary from 'react-icons/lib/md/playlist-add-check';

class DashboardCompletedRecord extends React.Component {

    render() {
        const { report } = this.props;
        const processingReport = (report.SuccessfulManifests / report.TotalManifests).toFixed(2) * 100;
        const identifier = report.Id;
        return (
            <div className={"timeline-box-w completed"}>
                <div className="timeline-time">
                    <span>
                        <TimeAgo>{ parseInt(moment(report.CreatedDate).format('x'), 0)}</TimeAgo>
                    </span>
                </div>
                <div className="timeline-box">
                    <div className="timeline-info">
                        <p className="timeline-role">
                            <IconMdAirplanemodeActive size="18" color="#43a8df"/>  <strong>{report.Airline}</strong> uploaded a file via <strong>{ InterpretStatus.pullModes(report.PullMode) }</strong>
                        </p>
                        <div>
                            <Container>
                                <Row>
                                    <Col sm="12">
                                        <footer style={{ paddingLeft: '20px'}} className="blockquote-footer pull-left">
                                            <IconMdDate size="18" color="#202021"/>
                                            &nbsp;<ToolTipItem key={identifier + 'createdDate'} title={moment((report.CreatedDate).split('T')[0]).format('MMM Do, YYYY')} content='Created Date ' id={ identifier + 'createdDate'}/> |
                                            &nbsp;<ToolTipItem key={identifier + 'processDate'} title={moment((report.ProcessDate).split('T')[0]).format('MMM Do, YYYY')} content='Processed Date' id={ identifier +  'processDate'}/>
                                            <span style={{paddingLeft: '25px'}}>&nbsp;</span>
                                            <ToolTipItem key={identifier + 'Successful'} title={<CompletedIcon color={'#00897b'} size="20" />} content='Successful Manifests' id={identifier + 'Successful'}/>{report.SuccessfulManifests} &nbsp;&nbsp;|
                                            &nbsp;&nbsp;<ToolTipItem key={identifier + 'Failed'} title={<FailedIcon color={'#b71c1c'} size="20" />} content='Failed Manifests' id={identifier + 'Failed'}/>{report.TotalManifests  - report.SuccessfulManifests}
                                            &nbsp;&nbsp;|&nbsp; <IconSummary size="18" color="#202021"/>
                                            &nbsp;&nbsp;
                                            { processingReport >= 50 &&
                                              processingReport + '% processed successfully'
                                            }
                                            { processingReport < 50 &&
                                              (100 - processingReport) + '% failed to be processed'
                                            }

                                        </footer>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DashboardCompletedRecord;



// WEBPACK FOOTER //
// ./src/views/dashboard/completed-record.js